import * as React from 'react';
import { FieldsProps, formValueSelector } from 'redux-form';
import { Button, Col, Row } from 'react-bootstrap';
import { ITraveller } from '../../../../../../data/api/models';
import { finishScreening, startScreening } from '../../../../../../services/verisk/reducer';
import Verisk from '../../../Verisk';
import { flow } from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { IStore } from '../../../../../../redux/IStore';
import { dateToApi } from '../../../../../../data/api/transformers/application';
import { FaUserAlt } from 'react-icons/fa';

interface ITravellersMedicalProps {
  fields: FieldsProps<any>;

  change(field: string, value: any): void;

  setIsScreening(isScreening: boolean): void;

  travellers: ITraveller[];
  destinations: string[];
  region: string[];
  verisk: any;
  tripType: string;
  startDate: string;
  endDate: string;
  isControlGroup?: boolean;

  setHasStartedAddingConditions?(value: boolean): void;
  setHasScreenedCondition?(value: boolean): void;

  dispatch();

  startScreening(travellerIndex, screeningId, region, destinations, dob, tripType, startDate, endDate, callback);

  finishScreening(callback);
}

interface ITravellersMedicalState {
  key: string | number;
  loading: boolean;
  sessionId: string;
  traveller: ITraveller;
  isScreening: boolean;
  url: string;
}

class TravellersMedical extends React.Component<ITravellersMedicalProps, ITravellersMedicalState> {
  public state = {
    key: null,
    loading: false,
    sessionId: null,
    traveller: null,
    isScreening: false,
    url: '',
  };

  private handleStartScreening = (traveller: ITraveller, key) => () => {
    this.props.setHasStartedAddingConditions(true);
    this.setState({
      loading: true,
      traveller,
      key,
    });

    const { region, destinations, startScreening, tripType, startDate, endDate } = this.props;

    const hasConditions = traveller.screening && traveller.screening.meta.conditions.length > 0;

    startScreening(
      key,
      hasConditions ? traveller.screeningSessionId : null,
      region,
      destinations,
      traveller.dob,
      tripType,
      dateToApi(startDate),
      dateToApi(endDate),
      (sessionId) => {
        this.props.setIsScreening(true);
        this.setState({
          loading: false,
          isScreening: true,
          sessionId,
        });
      }
    );

  }

  private getTravellerIndex = (id: string, fields) => {
    let travellerIndex = -1;
    const travellers = fields.getAll();

    travellers.forEach((traveller, index) => {
      if (traveller.id === id) {
        travellerIndex = index;
      }
    });

    if (travellerIndex === -1) {
      console.error('Couldn\'t find traveller', travellers, id, travellerIndex);
    }

    return travellerIndex;
  }

  private handleFinishScreening = () => {
    const { change, finishScreening, fields } = this.props;
    const { /*sessionId,*/ traveller } = this.state;

    const key = this.getTravellerIndex(traveller.id, fields);

    finishScreening((screening, screeningId) => {
      change(`travellers[${key}].screeningSessionId`, screeningId);
      change(`travellers[${key}].screening`, screening);

      this.props.setIsScreening(false);
      this.setState({
        traveller: null,
        sessionId: null,
        isScreening: false,
      });

      this.props.setHasStartedAddingConditions(false);

      this.forceUpdate();
    });
  }

  private renderConditions = (conditions: string[]) => {
    const { isControlGroup } = this.props;

    if (conditions.length === 0) {
      return (
        <p className="screened-conditions">
          {isControlGroup ? 'No medical conditions' : 'No Conditions Screened'}
        </p>
      );
    }

    return (
      <ul className="conditions-list">
        {conditions.map((condition, key) => (
          <li key={key}>{condition}</li>
        ))}
      </ul>
    );
  };

  private renderTravellers = (travellerName, key) => {
    const { travellers, isControlGroup } = this.props;
    const traveller: ITraveller = travellers[key];
    const hasConditions = !!traveller.screeningSessionId;
    const colLeftProps = isControlGroup ? { xs: 12, sm: 8 } : { xs: 8 };
    const colRightProps = isControlGroup ? { xs: 12, sm: 4 } : { xs: 4 };

    const buttonLabel = isControlGroup
      ? hasConditions ? 'Add, Edit or Remove' : 'Add'
      : hasConditions ? 'Edit' : 'Add';

    const rightColClass = [
      isControlGroup ? 'text-right-new' : 'text-right',
      'full-width-xs',
      hasConditions && isControlGroup && 'edit-conditions'
    ]
      .filter(Boolean)
      .join(' ');
    return (
    <div key={key} className="section-group">
      <div className={isControlGroup ? 'section traveller-header' : 'section'}>
        <div className={isControlGroup ? 'traveller-name' : ''}>
          {isControlGroup && <FaUserAlt className="traveller-icon" />}

          <div className="traveller-text">
            <strong>
              {traveller.firstName} {traveller.lastName}
            </strong>

            {isControlGroup && (
              <span className="med-cond-dob">
                ({traveller.dob})
              </span>
            )}
          </div>
        </div>
      </div>

      <div className={isControlGroup ? 'section traveller-condition-list' : 'section'}>
        <Row>
          <Col {...colLeftProps} className="full-width-xs">
            {this.renderConditions(
              hasConditions ? traveller.screening.meta.conditions : []
            )}
          </Col>

          <Col {...colRightProps} className={rightColClass}>
            <Button
              bsStyle="primary"
              onClick={this.handleStartScreening(traveller, key)}
              disabled={this.state.loading}
            >
              {buttonLabel} Condition
            </Button>
          </Col>
        </Row>
      </div>
    </div>
    );
  }

  private renderVeriskScreening = () => {
    const { verisk, dispatch, travellers, isControlGroup } = this.props;
    const { key } = this.state;
    const travellerName = travellers[key].firstName + ' ' + travellers[key].lastName;

    return (
      <div className="traveller-medical">
        <Verisk
          travellerName={travellerName}
          travellerDob={travellers[key].dob}
          index={key}
          screening={verisk}
          finishScreening={this.handleFinishScreening}
          dispatch={dispatch}
          isControlGroup={isControlGroup}
          setHasScreenedCondition={this.props.setHasScreenedCondition}
        />

        <div className="clearfix"/>
      </div>
    );
  }

  public render() {
    const { fields } = this.props;
    const { isScreening } = this.state;

    return (
      <div ref={`conditions`}>
        {!isScreening && fields.map(this.renderTravellers)}
        {isScreening && this.renderVeriskScreening()}
      </div>
    );
  }
}

let selector;

export default flow([
  (component) => {
    selector = formValueSelector('quote');

    return component;
  },
  connect(
    (state: IStore) => {
      const travellers = selector(state, 'travellers');
      const region = selector(state, 'region');
      const destinations = selector(state, 'destinations');
      const startDate = selector(state, 'startDate');
      const endDate = selector(state, 'endDate');
      const tripType = selector(state, 'tripType');

      return {
        travellers,
        region,
        destinations,
        startDate,
        endDate,
        tripType,
        verisk: state.verisk,
      };
    },
    (dispatch) => ({
      startScreening: bindActionCreators(startScreening, dispatch),
      finishScreening: bindActionCreators(finishScreening, dispatch),
      dispatch,
    }),
  ),
])(TravellersMedical);
